import './App.css';
import RootRoutes from './routes/routes';
import { useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { platforms } from './common/constant';
import { deleteUserSession, createUserSession } from './services/user.service';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from './store/store';
import { setUserOpSession, setUserJiraSession } from './store/userSlice';
import { setTrackingState } from './store/trackingSlice';



function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const opSessionId = useSelector((state: RootState) => state.user.opSessionId);
  const jiraSessionId = useSelector((state: RootState) => state.user.jiraSessionId);

  const handleBackButton = async () => {
    // If the user is navigating away from /home, call the API
    if (location.pathname === '/login') {
      if (opSessionId)
        dispatch(setUserOpSession(null));
      if (jiraSessionId)
        dispatch(setUserJiraSession(null));
      clearSession();
    }
  };

  useEffect(() => {
    handleAuthCodeInParams();
  }, [location]);

  const handleAuthCodeInParams = () => {
    const searchParams = new URLSearchParams(location.search);
    const authCode = searchParams.get('code');
    const state = searchParams.get('state');

    console.log('[CODE_RECEIVED_STATE]', state)
    if (authCode && state) {
      // localStorage.setItem( 'authCode', authCode);
      localStorage.setItem(state, authCode);
      window.close();
    }
  };


  useEffect(() => {
    // Listen for the back button event
    window.addEventListener('popstate', handleBackButton);

    // window.addEventListener('beforeunload', () => {
    //   clearSession();
    // });

    // window.addEventListener('beforeunload', () => {
    //   clearSession();
    // });

    window.addEventListener('storage', (event) => {
      if ((event.key === 'jiraSessionId' && jiraSessionId !== event?.newValue) ||
        (event.key === 'opSessionId' && opSessionId !== event?.newValue)) {
        //  dispatch(setSessionExpire(true)) Testing
        dispatch(setTrackingState(false))
        navigate('/login');
      }
    })

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, []);

  return (
    <div className="App">
      <RootRoutes />
    </div>
  );
}

export const clearSession = async () => {
  const openProjectLoginDetails = localStorage.getItem('openProjectLoginDetails') ? JSON.parse(localStorage.getItem('openProjectLoginDetails') || '') : '';
  const jiraLoginDetails = localStorage.getItem('jiraLoginDetails') ? JSON.parse(localStorage.getItem('jiraLoginDetails') || '') : '';

  if (openProjectLoginDetails?.userDetails?.email) {
    const opSessionDetails = await deleteUserSession(openProjectLoginDetails?.userDetails?.email, platforms.OPEN_PROJECT);

    if (opSessionDetails?.statusCode === 200) {
      console.log("OP - " + opSessionDetails?.message);
    }
    localStorage.removeItem('openProjectAccessToken');
    localStorage.setItem('opSessionId', 'null');
  }

  if (jiraLoginDetails?.userDetails?.emailAddress) {
    const jiraSessionDetails = await deleteUserSession(jiraLoginDetails?.userDetails?.emailAddress, platforms.JIRA);

    if (jiraSessionDetails?.statusCode === 200) {
      console.log("JIRA - " + jiraSessionDetails?.message);
    }
    localStorage.removeItem('jiraAccessToken');
    localStorage.setItem('jiraSessionId', 'null');
    localStorage.removeItem('jiraAccessToken');
    // localStorage.setItem('jiraAccessToken', 'null'); future use
  }
}

export const createSession = async () => {
  const sessionIds = { opSessionId: null, jiraSessionId: null };

  const openProjectLoginDetails = localStorage.getItem('openProjectLoginDetails') ? JSON.parse(localStorage.getItem('openProjectLoginDetails') || '') : '';
  const jiraLoginDetails = localStorage.getItem('jiraLoginDetails') ? JSON.parse(localStorage.getItem('jiraLoginDetails') || '') : '';

  if (openProjectLoginDetails) {
    const opSession = await createUserSession({
      email: openProjectLoginDetails.userDetails.email,
      platform: platforms.OPEN_PROJECT,
      accountId: openProjectLoginDetails.userDetails.id,
    });
    if (opSession?.statusCode === 200 && opSession?.data?.id) {
      localStorage.setItem('opSessionId', opSession.data.id);
      sessionIds.opSessionId = opSession.data.id;
    }
  }

  if (jiraLoginDetails) {
    const jiraSession = await createUserSession({
      email: jiraLoginDetails.userDetails.emailAddress,
      platform: platforms.JIRA,
      accountId: jiraLoginDetails.userDetails.accountId,
    });
    if (jiraSession?.statusCode === 200 && jiraSession?.data?.id) {
      localStorage.setItem('jiraSessionId', jiraSession.data.id);
      sessionIds.jiraSessionId = jiraSession.data.id;
    }
  }

  return sessionIds;
}

export default App;
